import { Skeleton, Stack } from "@mui/material";
import MuiTab from "@mui/material/Tab";
import MuiTabs from "@mui/material/Tabs";
import SiteContext from "components/SiteContext";
import Link from "components/templatesComponents/Link";
import { tabsStyled, tabStyled } from "components/templatesComponents/TabsStyled";
import { useFindPagesByTemplateKeys } from "hooks/page.hook";
import PropTypes from "prop-types";
import React from "react";
import elementsTypes from "utils/elementsTypes";

const complementaryTabsStyled = { mt: { xs: 3, lg: 2.5 }, mb: { xs: 2, lg: 4.5 } };

const getAllNewsPageSiteName = (page) =>
  page?.contents?.find((content) => content.type === elementsTypes.SITE_NAME)?.value;

const NewsTabs = (props) => {
  const { currentPageVersion } = props;
  const { page: currentPage } = currentPageVersion;
  const { lang = "FR" } = currentPage;

  const site = React.useContext(SiteContext);
  const { name: currentSiteName } = site || {};

  const { data: pages = [], isLoading } = useFindPagesByTemplateKeys({
    templates: ["ALLNEWS", "LASTNEWS"],
    siteName: currentSiteName,
    filters: [`page.lang||eq||${lang}`],
    sort: ["updated,DESC"],
  });

  const tabPages = pages?.pages || pages;

  React.useMemo(() => {
    if (Array.isArray(tabPages) && currentSiteName) {
      const getPageOrder = (page) => {
        switch (getAllNewsPageSiteName(page)) {
          case "allSites":
            return 0;
          case currentSiteName:
            return 1;
          case "IMMAT":
            return 2;
          case "PASSEPORT_CNI":
            return 3;
          case "PERMIS":
            return 4;
          default:
            return Infinity;
        }
      };
      tabPages.sort((pageA, pageB) => {
        if (pageB.template === pageA.template) {
          if (pageA.template === "ALLNEWS") {
            return getPageOrder(pageA) - getPageOrder(pageB);
          }
          return 0;
        }
        if (pageA.template === "ALLNEWS") {
          return -1;
        }
        return 1;
      });
    }
  }, [tabPages, currentSiteName]);

  if (isLoading) {
    return (
      <Stack sx={{ ...tabsStyled, ...complementaryTabsStyled }} direction={{ xs: "column", md: "row" }}>
        <Skeleton variant="rounded" width={165} height={42} />
        <Skeleton variant="rounded" width={165} height={42} />
      </Stack>
    );
  }

  if (!Array.isArray(tabPages) || tabPages.length === 0) {
    return null;
  }

  return (
    <MuiTabs
      value={currentPageVersion?.pageId}
      variant="scrollable"
      indicatorColor="none"
      selectionFollowsFocus
      sx={{ ...tabsStyled, ...complementaryTabsStyled }}
    >
      {Array.isArray(tabPages) &&
        tabPages.map((page) => (
          <MuiTab
            key={page.id}
            label={page.title}
            value={page.pageId}
            component={Link}
            url={page.fullPath}
            page={page}
            sx={{ ...tabStyled, backgroundImage: "none" }}
          />
        ))}
    </MuiTabs>
  );
};

NewsTabs.propTypes = {
  currentPageVersion: PropTypes.shape().isRequired,
};

export default NewsTabs;
